import axios from "axios";
import beveatApiResourceOwner from "../../../../api/resource_owner_beveat_api.js";
import { useEffect, useMemo, useState } from "react";
import ProgressSpinner from "../../../components/progress_spinner.jsx";
import Table from "../../../components/table.jsx";
import { INVOICE_PLAN_SYSCODE } from "../../../../constants/invoice_plan_syscode.jsx";
import { commonConfigs, urls } from "../../../../../config.js";
import { getUser } from "../../../../services/local_service.js";
import { ProjectStatus } from "./project_status.jsx";
import { INVOICE_STATUS } from "../../../../constants/invoice_status.jsx";
import { INVOICE_SYSCODE } from "../../../../constants/invoice_syscode.jsx";
import { PLATFORM_SYSCODE, PlatformSyscodeString } from "../../../../constants/platform_syscode.jsx";
import { Edit } from "iconsax-react";
import { DEVELOPER_PROJ_STATUS } from "../../../../constants/developer_proj_status.jsx";
import UpdateProjectModal from "../../../components/update_project_modal.jsx";
import { DEVELOPER_PROJ_TABLE_SYSCODE } from "../../../../constants/developer_proj_table_syscode.jsx";

export default function ProjectRelease({ currentTab }) {
  const [load, setLoad] = useState(true);
  const [isUpdateProjModalOpen, setUpdateProjModalOpen] = useState(false);
  const [selectedProj, setSelectedProj] = useState(null);
  const [devProjs, setDevProjs] = useState([]);
  const accountId = getUser()?.account_id;

  const mockData = [
    { developer_proj_id: "proj1", developer_proj_name: "Dev1", developer_proj_website_url: "Example1.com", created_on: "2025-01-08 14:37:51.000", platform_syscode: 100, platform_type: PLATFORM_SYSCODE.eCommerce_Website, developer_proj_status: 1 },
    { developer_proj_id: "proj1.1", developer_proj_name: "Dev1", developer_proj_website_url: "Example1.com", created_on: "2025-01-08 14:37:51.000", platform_syscode: 101, platform_type: PLATFORM_SYSCODE.eCommerce_Mobile, developer_proj_status: 1 },
    { developer_proj_id: "proj2", developer_proj_name: "Dev2", developer_proj_website_url: "Example2.com", created_on: "2025-02-09 14:37:51.000", platform_syscode: 101, platform_type: PLATFORM_SYSCODE.eCommerce_Mobile, developer_proj_status: 2 },
    { developer_proj_id: "proj3", developer_proj_name: "Dev3", developer_proj_website_url: "Example3.com", created_on: "2025-03-09 14:37:51.000", platform_syscode: 102, platform_type: PLATFORM_SYSCODE.eCommerce_Kiosk, developer_proj_status: 3 },
  ]

  useEffect(() => {
    async function init() {
      try {
        await getDeveloperProjs();
        setLoad(false);
      } catch (err) {
        console.error("Initialization error:", err);
      }
    }
    init();
  }, []);

  async function getDeveloperProjs() {
    const url = urls.resourceOwnerUrl + commonConfigs.apiUrls.adminGetAllDeveloperProjects(DEVELOPER_PROJ_TABLE_SYSCODE.PRODUCTION);
    const res = await beveatApiResourceOwner.get(url, {
      headers: commonConfigs.resourceOwnerApiHeader,
    });
    setDevProjs(res.data.result.data);
  }

  // Filter the data based on currentTab value
  const filteredData = useMemo(() => {
    let data = devProjs;
    if (!currentTab || !devProjs) data = mockData;

    return data.filter(item =>
      item.developer_proj_status === currentTab.value
    );
  }, [currentTab, devProjs]);

  const handleOpenModal = (proj) => {
    setSelectedProj(proj);
    setUpdateProjModalOpen(true);
  };

  const handleCloseModal = () => {
    setUpdateProjModalOpen(false);
    setSelectedProj(null);
  };

  const columns = useMemo(() => [
    {
      Header: "Project ID",
      accessor: "developer_proj_id",
    },
    {
      Header: "Project Name",
      accessor: "developer_proj_name",
    },
    {
      Header: "Website URL",
      accessor: "developer_proj_website_url",
    },
    {
      Header: "Created On",
      accessor: "created_on",
      Cell: ({ value }) => {
        const createdDate = new Date(value)
          .toISOString()
          .split("T")[0];
        return createdDate ? createdDate : '-';
      },
    },
    {
      Header: "Platform",
      accessor: "platform_syscode",
      Cell: ({ value }) => { return PlatformSyscodeString[value] }
    },
    {
      Header: "Project Status",
      accessor: "developer_proj_status",
      Cell: ({ cell: { value } }) => <ProjectStatus value={value} />,
    },
    {
      id: "Actions",
      width: 25,
      Cell: ({ row }) => {
        return (
          <button
            data-inline="true"
            type="button"
            className={`
              w-full inline-flex justify-center rounded-full border border-transparent shadow-sm px-0.5 py-1 text-medium font-bold sm:text-sm 
              hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500`
            }
            disabled={false}
            onClick={() => handleOpenModal(row.original)}
          >
            {currentTab.value == DEVELOPER_PROJ_STATUS.Pending_Release ? "Release" : "Update"}
          </button>
        )
      }
    }
  ]);

  return (
    <>
      {/* Table Section */}
      {mockData != null ? (
        <div style={{
          overflowX: "visible",
          marginBottom: undefined
        }}>
          <Table
            columns={columns}
            data={filteredData}
            filters={columns.map((column) => column.accessor)}
          />
        </div>
      ) : (
        <div className={`${isMobile ? 'w-full h-96' : 'w-screen h-screen'} flex flex-wrap flex-row place-items-center`}>
          <div className="flex place-content-center w-full">
            <div className="text-center">
              <ProgressSpinner className={`${isMobile ? 'w-12 h-12' : 'w-20 h-20'}`} />
              {isMobile && (
                <p className="mt-4 text-gray-600 text-sm">
                  Loading Projects...
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modals */}
      {isUpdateProjModalOpen && (
        <UpdateProjectModal
          mode="admin"
          setOpenModal={handleCloseModal}
          data={selectedProj}
          // devProj={selectedProj}
          currentTab={currentTab}
          tableSyscode={DEVELOPER_PROJ_TABLE_SYSCODE.PRODUCTION}
        />
      )}
    </>
  );
}